import { render, staticRenderFns } from "./map.vue?vue&type=template&id=13a972ce&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports